<template>
  <perfect-scrollbar :options="options" :style="styles">
    <slot />
  </perfect-scrollbar>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'CfsPerfectScrollbar',
  props: {
    scrollX: {
      type: Boolean,
      default: true,
    },
    scrollY: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: '',
    },
    maxHeight: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const options = computed(() => {
      return {
        suppressScrollX: !props.scrollX,
        suppressScrollY: !props.scrollY,
      };
    });
    const styles = computed(() => {
      return {
        ...(props.height ? { height: props.height } : {}),
        ...(props.maxHeight ? { maxHeight: props.maxHeight } : {}),
      };
    });
    return { options, styles };
  },
});
</script>

<style lang="scss">
.ps {
  &--active-y {
    @apply pr-[10px] #{!important};
  }
  &__rail-y {
    @apply opacity-60 #{!important};
  }
  &__rail-x:hover,
  &__rail-y:hover,
  &__rail-y:focus {
    background-color: transparent !important;

    .ps__thumb-x {
      @apply h-[6px] #{!important};
    }

    .ps__thumb-y {
      @apply w-[6px] #{!important};
    }
  }

  &__thumb-x,
  &__thumb-y {
    background-color: var(--v-primary-base) !important;
  }
}
</style>
